export const SDK_VERSION = '6.18.2';
